export function convertDateToLocal(date) {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Date(date).toLocaleString("en-US", { timeZone });
}
